export default __webpack_public_path__ + "static/media/ssl.0190310f.svg";